import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import CoreMap from '@bd/bdui-coremap';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors } from '../../styles';


const styles = css`
  padding: 30px 0;
  @media(min-width: 992px) {
    padding: 90px 0;
  }
  .Map_wrapper{
    height:500px;
    width:100%;
    background-color: #c1c1c1;
    padding:0;
  }
  .MapSection_title {
    font-size: 36px;
    line-height: 40px;
    color: ${colors.color1};
  }
  .MapSection_content {
    padding: 0;
    @media(min-width:992px) {
      padding: 0 0 0 50px;
    }
  }
  .MapSection_directionsBtnWrapper {
    margin: 20px auto;
    @media(min-width: 992px) {
      margin: 20px 0;
    }
  }
  .Btn {
    width: fit-content;
  }
`;


function ContactUs({ page, builder }) {
  return (
    <div className={styles}>
      <div className="MapSection_wrapper">
        {
          get(page, 'map_section').map(item => (
            <div className="MapSection_innerWrapper" key={item.title}>
              {
                get(item, 'title') &&
                <div className="">
                  <h3 className="MapSection_title">{get(item, 'title')}</h3>
                </div>
              }

              <div className="d-lg-flex justify-content-center" key={item.title}>

                <div className="col-lg-6 px-0">
                  <CoreMap
                    pin={{
                      iconUrl: '/images/map-pin.svg',
                      iconSize: [32, 46],
                      iconAnchor: [16, 46],
                    }}
                    className={css`
                      position: relative;
                      padding-bottom: 56.25%;
                      width: 100%;
                      height:100%;
                      z-index: 0;
                      background-color: ${colors.color1};
                      .leaflet-container {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                      }
                    `}
                    markers={[builder]}
                  />

                </div>

                <div className="col-lg-6 MapSection_content">
                  <div className="MapSection_directions" dangerouslySetInnerHTML={SanitizeHtml(item.directions)} />

                  {
                    get(item, 'button_url') && get(item, 'button_text') &&
                    <div className="MapSection_directionsBtnWrapper">
                      <a className="Btn" href={get(item, 'button_url')} target="_blank" rel="naopener noreferrer">
                        {get(item, 'button_text')}
                      </a>
                    </div>
                  }
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

ContactUs.propTypes = {
  builder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'contact_us',
  builder: true,
})(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/MapSection.js